module.exports = __webpack_public_path__ + "img/index-zt4.c963d765.png";